import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Typography, Stepper } from '../../components'
import { DefaultRegularPages } from '../DefaultPages'

import useActions from '../../hooks/useActions'
import { signUpActions } from '../../redux/ducks/signUp'
import { loginActions } from '../../redux/ducks/login'
import FinishStep from './FinishStep'
import StepOne from './Step1'
import StepTwo from './Step2'
import StepThree from './Step3'
import StepFour from './Step4'

import * as S from './styles'
import { useModal } from '../../hooks/useModal'
import { MessageModal } from '../../modals/MessageModal'
import { signUpStepIcons } from '../../constants/signUp'
import { ModalBodyContainer } from '../../modals/styles'

const Signup = () => {
  const { resetState } = useActions(signUpActions)
  const { logout } = useActions(loginActions)
  const { actualStep, step1 } = useSelector((state) => state.signUp)
  const { isLogged } = useSelector((state) => state.login)
  const [renderMessageModal, openMessageModal] = useModal(MessageModal)

  const openModalLoggedOutInfo = useCallback(
    () =>
      openMessageModal({
        title: 'Atenção',
        body: (
          <ModalBodyContainer>
            <Typography type="text" color="#7D7987">
              Para dar início a um novo cadastro você foi desconectado. Caso
              seja necessário efetue login novamente.
            </Typography>
          </ModalBodyContainer>
        )
      }),
    [openMessageModal]
  )

  useEffect(() => {
    if (actualStep > 1 && step1.cnpj === '') {
      resetState()
    }
  }, [actualStep, resetState, step1])

  useEffect(() => {
    if (isLogged) {
      logout()
      openModalLoggedOutInfo()
    }
  }, [isLogged, logout, openModalLoggedOutInfo])

  useEffect(() => {
    return () => {
      resetState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DefaultRegularPages>
      {renderMessageModal}
      <S.Container>
        <Typography type="h2" color="#151515" spacing="32px 0 0 0">
          Cadastra-se
        </Typography>
        <Stepper stepIcons={signUpStepIcons} filling={actualStep} />
        {actualStep === 1 && <StepOne />}
        {actualStep === 2 && <StepTwo />}
        {actualStep === 3 && <StepThree />}
        {actualStep === 4 && <StepFour />}
        {actualStep === 5 && <FinishStep />}
      </S.Container>
    </DefaultRegularPages>
  )
}

export default Signup
